import React, {useState, useEffect} from 'react';
import {getEORMintInfo, getCoachMintInfo, mintEORNFTS, mintCoachNFTS} from './helpers/racefunctions';
import rookie from '../images/badge_rookie.png';
import racer_logo from '../images/orl_racers.png';
import { Modal } from 'bootstrap';


function MintPanel({walletAddress, setModalInfo}){

    const [tonePrice, setTonePrice] = useState(0);
    const [toneExcPrice, setToneExcPrice] = useState(0);
	const [excPrice, setExcPrice] = useState(0);
    const [toneTotal, setToneTotal] = useState(0);
	const [toneMinted, setToneminted] = useState(0);
	const [excTotal, setExcTotal] = useState(0);
	const [excMinted, setExcMinted] = useState(0);
    const [maxMint, setMaxMint] = useState(0);
	const [toneAD, setToneAD] = useState(0);
    const [toneExcAD, setToneExcAD] = useState(0);
	const [excAD, setExcAD] = useState(0);
	const [coachAD, setCoachAD] = useState(0);
    const [tOneQty, setTOneQty] = useState(0);
	const [excQty, setExcQty] = useState(0);
	const [useTAD, setUseTAD] = useState(false);
	const [useEAD, setUseEAD] = useState(false);
	const [useCAD, setUseCAD] = useState(false);
	const [coachMinted, setCoachMinted] = useState(0);
	const [coachTotal, setCoachTotal] = useState(0);
	const [coachPrice, setCoachPrice] = useState(0);
	const [coachQty, setCoachQty] = useState(0);

    
    useEffect(() =>{

        getMintInfo();
    },[walletAddress])

    const getMintInfo= async(account) => {
		let toneMint = 0;
		let excMint = 0;
		let _maxMint = 0;
		let totToneMint = 0;
		let totExcMint = 0;
		let coachesMinted = 0;
		let coachesPrice = 0;
		let totCoachMint = 0;
		let coachAirDrops = 0;

		//document.getElementById("demo").innerHTML = ("");
        const racerMintsObj = await getEORMintInfo(walletAddress);
        const coachMintObj = await getCoachMintInfo(walletAddress);
		toneMint = racerMintsObj.tone;
		setToneminted(parseInt(toneMint));
		excMint = racerMintsObj.exc;
		setExcMinted(parseInt(excMint));
		coachesMinted = coachMintObj.coachmint
		setCoachMinted(parseInt(coachesMinted));

		let tOnePrice;
		let excPrice;
        let tOneExcPrice;
		tOnePrice = racerMintsObj.toneprice;
		excPrice = racerMintsObj.excprice;
        tOneExcPrice = racerMintsObj.toneexcprice;
		coachesPrice = coachMintObj.coachcost;
		coachAirDrops = coachMintObj.freemints;
		_maxMint = racerMintsObj.maxexclu;
		_maxMint = parseInt(_maxMint);
		setExcAD(parseInt(racerMintsObj.excdrops));
		setToneAD(parseInt(racerMintsObj.tonedrops))
        setToneExcAD(parseInt(racerMintsObj.toneexcdrops));
		setCoachAD(parseInt(coachAirDrops));
		if (_maxMint > 0 || racerMintsObj.excdrops > 0) {
			setExcQty(1);
		}else{
			setExcQty(0);
		}
		setMaxMint(_maxMint);
		setTonePrice((tOnePrice / 1000000000000000000));
		setExcPrice((excPrice / 1000000000000000000));
        setToneExcPrice((tOneExcPrice / 1000000000000000000));
		setCoachPrice(coachesPrice / 1000000000000000000)
		if (useTAD){
			setUseTAD(false);
		}

		totToneMint = racerMintsObj.totaltone;
		totExcMint = racerMintsObj.totExc;
		totCoachMint = await coachMintObj.totalmints;
		setToneTotal(parseInt(totToneMint));
		setExcTotal(parseInt(totExcMint));
		setCoachTotal(parseInt(totCoachMint));
	}

    const mintNftHandler = async (minttype) => {
        try {
            
            
                    var mintNum = (minttype === 1 ? tOneQty : excQty);
					if (mintNum < 1){
						document.getElementById("log").innerHTML = ("Please increase qty above 0 before minting.");
						return false;
					}

                    let nftPrice = (minttype === 1 ? (useTAD ? 0 : (toneExcAD > 0 ? toneExcPrice : tonePrice)) : (useEAD ? 0 : excPrice));

            //        document.getElementById("log").innerHTML = ("Initialise wallet...<br>");
            
                    let myNameModal = new Modal(document.getElementById('showAlerts'));
                    setModalInfo({"message":'Waiting on wallet authorization.',"type":'nftmint'})
                    myNameModal.show();
                    let nftResults = await mintEORNFTS(walletAddress, mintNum, minttype, (nftPrice * mintNum));
                        if (nftResults !== undefined){
                            if (nftResults.blockNumber !== '' && nftResults.blockNumber !== undefined){
                                setModalInfo({"message":'Minting completed.',"type":'nftmintcomp'})
                            }else {
                                setModalInfo({"message":'Error trying to mint. Please try again.  message:' + nftResults,"type":'error'});
                                return false;
                            }
                        }else {
                            setModalInfo({"message":'User has rejected the transaction.',"type":'error'});
                            return false;
        
                        }
                    
            //        await nftTxn.wait();
                    //document.getElementById("log").innerHTML = ("Success! See transaction <a target='_blank' href='https://polygonscan.com/tx/" + nftTxn.hash + "' >here.</a><br>");
                    
					getMintInfo(walletAddress);
	


        } catch (err) {
            console.log(err);
            document.getElementById("log").innerHTML = (err.message + "</br>" + document.getElementById("log").innerHTML);
            if (err.data != null) {

                document.getElementById("demo").innerHTML = err.data.message;
            }

        }

    }

	const mintCoachNftHandler = async () => {
        try {
            

   
                    var mintNum = coachQty;
					if (mintNum < 1){
						document.getElementById("log").innerHTML = ("Please increase qty above 0 before minting.");
						return false;
					}

                    let nftPrice = (useCAD ? 0 : coachPrice);

                   let myNameModal = new Modal(document.getElementById('showAlerts'));
                    setModalInfo({"message":'Waiting on wallet authorization.',"type":'nftmint'})
                    myNameModal.show();
                    let nftResults = await mintCoachNFTS(walletAddress,  mintNum, (nftPrice * mintNum));
                        if (nftResults !== undefined){
                            if (nftResults.blockNumber !== '' && nftResults.blockNumber !== undefined){
                                setModalInfo({"message":'Coach Minting completed.',"type":'nftmintcomp'})
                            }else {
                                setModalInfo({"message":'Error trying to mint. Please try again. Reason: ' + nftResults,"type":'error'});
                                return false;
                            }
                        }else {
                            setModalInfo({"message":'User has rejected the transaction.',"type":'error'});
                            return false;
        
                        }
                 
					getMintInfo(walletAddress);



        } catch (err) {
            console.log(err);
            document.getElementById("log").innerHTML = (err.message + "</br>" + document.getElementById("log").innerHTML);
            if (err.data != null) {

                document.getElementById("demo").innerHTML = err.data.message;
            }

        }

    }

    const useTone = async() => {
        let _usetone = document.getElementById('usetonead').checked;
        setUseTAD(_usetone);
        if (tOneQty > toneAD){
            setTOneQty(toneAD);
        }
    }
    
    const useCoach = async() => {
        let _usecoach = document.getElementById('usecoachad').checked;
        setUseCAD(_usecoach);
        if (coachQty > coachAD){
            setCoachQty(coachAD);
        }
    }
    
    const useExc = async() => {
        let _useexc = document.getElementById('useexcad').checked;
        setUseEAD(_useexc);
        if (excQty > excAD){
            setExcQty(excAD);
        }
    }

    const upOrDown = () => {
        var _tOneQty = tOneQty + 1
        if (_tOneQty > 50){
                    alert('You cannot mint more then 50 at one time.');
                    return false;
                }
        if (useTAD && tOneQty < toneAD) {
            setTOneQty(_tOneQty);
        }else if (!useTAD){
            if (toneExcAD === 0 || tOneQty < toneExcAD){
                setTOneQty(_tOneQty);
            }else{
                if (toneExcAD > 0){
                    alert('You cannot mint more then ' + toneExcAD + ' at the discounted price.')
                }
                
            }
			
		}
  
        return;
    }
    const downJustDown = () => {
        var _tOneQty = tOneQty - 1
        if (tOneQty > 1) {
            setTOneQty(_tOneQty);
        }
        return;
    }

	const upOrDownExc = () => {
        var _excQty = excQty + 1
                if (_excQty > 50){
                    alert('You cannot mint more then 50 at one time.');
                    return false;
                }
        if (excQty < maxMint || excQty < excAD) {
            setExcQty(_excQty);
        }else{
			document.getElementById("log").innerHTML = ("You currently have no more exclusive mints.");
		}
  
        return;
    }
    const downJustDownExc = () => {
        var _excQty = excQty - 1
        if (excQty > 1) {
            setExcQty(_excQty);
        }
        return;
    }

	const upOrDownCoach = () => {
        var _coachQty = coachQty + 1
        if (useCAD && coachQty < coachAD) {
            setCoachQty(_coachQty);
        }else if (!useCAD){
			setCoachQty(_coachQty);
		}
  
        return;
    }
    const downJustDownCoach = () => {
        var _coachQty = coachQty - 1
        if (coachQty > 1) {
            setCoachQty(_coachQty);
        }
        return;
    }

	const mintNftButton = () => {
        var mintNum = tOneQty;
        let nftPrice = (useTAD ? 0 : (toneExcAD > 0 ? toneExcPrice :tonePrice));
        let _tot = mintNum * nftPrice;
        return (
            <>
                <button onClick={() => mintNftHandler(1)} className='cta-button mint-nft-button'>
                    Mint for {_tot} $POL
                </button>
            </>
        )
    }

	const mintNftExcButton = () => {
        var mintNum = excQty;
        let nftPrice = (useEAD ? 0 : excPrice);
        let _tot = mintNum * nftPrice;
        return (
            <>
                <button onClick={() => mintNftHandler(2)} className='cta-button mint-nft-button'>
                    Mint for {_tot} $POL
                </button>
            </>
        )
    }

	const mintNftCoachButton = () => {
        var mintNum = coachQty;
        let nftPrice = (useCAD ? 0 : coachPrice);
        let _tot = mintNum * nftPrice;
        return (
            <>
                <button onClick={() => mintCoachNftHandler()} className='cta-button mint-nft-button'>
                    Mint for {_tot} $POL
                </button>
            </>
        )
    }

    const incMint = () => {
        return (
            <button onClick={upOrDown} className='cta-button plus-minus-button'>
                +
            </button>
        )
    }
    const decMint = () => {
        return (
            <button onClick={downJustDown} className='cta-button plus-minus-button'>
                -
            </button>
        )
    }

	const incMintExc = () => {
        return (
            <button onClick={upOrDownExc} className='cta-button plus-minus-button'>
                +
            </button>
        )
    }
    const decMintExc = () => {
        return (
            <button onClick={downJustDownExc} className='cta-button plus-minus-button'>
                -
            </button>
        )
    }

	const incMintCoach = () => {
        return (
            <button onClick={upOrDownCoach} className='cta-button plus-minus-button'>
                +
            </button>
        )
    }
    const decMintCoach = () => {
        return (
            <button onClick={downJustDownCoach} className='cta-button plus-minus-button'>
                -
            </button>
        )
    }

    return <div style={{paddingTop:'20px'}}>
    <div>{maxMint} Exclusive Mints Available (6 POL)</div>
    <div>{toneExcAD} T1 Loyalty Mints Available (8 POL otherwise 25 POL)</div>
    <div>{excAD} Free Exclusive Mints Available <input type="checkbox" id="useexcad" checked={useEAD} onChange={useExc} style={{display:(excAD !== 0 ? 'unset' : 'none'), width:'unset'}} /> <span style={{display:(excAD !== 0 ? 'unset' : 'none')}}>Use Free Exclusive Mints?</span></div> 
    <div>{toneAD} Free T1 Mints Available <input type="checkbox" id="usetonead" checked={useTAD} onChange={useTone} style={{display:(toneAD !== 0 ? 'unset' : 'none'), width:'unset'}} /> <span style={{display:(toneAD !== 0 ? 'unset' : 'none')}}>Use Free T1 Mints?</span></div> 
    <div>{coachAD} Free Coach Mints Available <input type="checkbox" id="usecoachad" checked={useCAD} onChange={useCoach} style={{display:(coachAD !== 0 ? 'unset' : 'none'), width:'unset'}} /> <span style={{display:(coachAD !== 0 ? 'unset' : 'none')}}>Use Free Coach Mints?</span></div> 
    <hr />
                   <div id="log"></div>
<div className="row">
                   <div id="left" className="col-md-4"><img src={racer_logo} alt="rookie logo" style={{width:'200px', paddingBottom:'10px'}} /><div  style={{fontSize:'1.2em', fontWeight:'bold'}}>T1 Racer<br/>Mint:</div>
                   <div style={{backgroundColor:'rgba(0,0,0,0.3)', width:'80%', marginLeft:'auto', marginRight:'auto', marginTop:'30px'}}>
    
    
    {decMint()}     <label id="up" >Mint {tOneQty} NFTs</label>   {incMint()}
    <br></br>
    <div id="wide" className="wide" style={{marginTop:'0px', paddingTop:'10px', paddingBottom:'10px'}}>
    {mintNftButton()}<br></br>
    <div id="progress" style={{paddingTop:'20px', paddingBottom:'20px'}}>{toneMinted} / {toneTotal}</div>
    </div>
</div>
</div>
<div id="right" className="col-md-4"><img src={racer_logo} alt="rookie logo" style={{width:'200px', paddingBottom:'10px'}} /><div style={{fontSize:'1.2em', fontWeight:'bold'}}>T2/3 Racer<br/><span style={{fontStyle:'italic', fontWeight:'lighter'}}>(Exclusive)</span> Mint:</div>
    <div style={{backgroundColor:'rgba(0,0,0,0.3)', width:'80%', marginLeft:'auto', marginRight:'auto', marginTop:'30px'}}>
    
    
    {decMintExc()}     <label id="up" >Mint {excQty} NFTs</label>   {incMintExc()}
    <br></br>
    <div id="wide" className="wide" style={{marginTop:'0px', paddingTop:'10px', paddingBottom:'10px'}}>
    {mintNftExcButton()}<br></br>
    <div id="progress" style={{paddingTop:'20px', paddingBottom:'20px'}}>{excMinted} / {excTotal}</div>
    </div>
</div>
</div>

<div id="right" className="col-md-4"><img src={rookie} alt="coach logo" style={{width:'120px', paddingBottom:'10px'}} /><div style={{fontSize:'1.2em', fontWeight:'bold'}}>Rookie Coach<br/>Mint:</div>
    <div style={{backgroundColor:'rgba(0,0,0,0.3)', width:'80%', marginLeft:'auto', marginRight:'auto', marginTop:'30px'}}>
    
    
    {decMintCoach()}     <label id="up" >Mint {coachQty} NFTs</label>   {incMintCoach()}
    <br></br>
    <div id="wide" className="wide" style={{marginTop:'0px', paddingTop:'10px', paddingBottom:'10px'}}>
    {mintNftCoachButton()}<br></br>
    <div id="progress" style={{paddingTop:'20px', paddingBottom:'20px'}}>{coachMinted} / {coachTotal}</div>
    </div>
</div>
</div>

</div>
</div>
}


export {MintPanel}